<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline" labelAlign="right">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="类型">
                <a-select placeholder="请选择" v-model="queryParam.packageType" style="width: 100%" allow-clear>
                  <a-select-option :key="item.id" v-for="item in packageTypes"> {{ item.name }} </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="名称">
                <a-input v-model="queryParam.packageName" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24" v-if="advanced">
              <a-form-item label="状态">
                <a-select placeholder="请选择" v-model="queryParam.status" style="width: 100%" allow-clear>
                  <a-select-option :value="0"> 禁用 </a-select-option>
                  <a-select-option :value="1"> 启用 </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="创建时间">
                <a-range-picker
                  v-model="value"
                  format="YYYY-MM-DD"
                  :placeholder="['开始时间', '结束时间']"
                  @change="onChangeTime"
                />
              </a-form-item>
            </a-col>
            <a-col :md="(!advanced && 6) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
              >
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operations">
        <a-button
          type="primary"
          @click="$refs.CreateForm.handleAdd(null, queryParam.packageType)"
          v-hasPermi="['edc3d11367c10d4dd99dddeaf314fcecc:0:c']"
        >
          新增
        </a-button>
        <a-button
          type="primary"
          @click="handleExport"
          v-hasPermi="['f1cd1866042366980928047f4b501a4de:0:e']"
          :disabled="value.length ? false : true"
        >
          导出
        </a-button>
      </div>
      <CreateForm ref="CreateForm" @ok="getList"></CreateForm>
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{
          type: isSingleSelect ? 'radio' : 'checkbox',
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
        }"
        :pagination="false"
      >
        <span slot="coverImageUrl" slot-scope="text, record">
          <div v-viewer v-if="record.coverImageUrl">
            <img :src="$url + record.coverImageUrl" alt="" style="width: 50px; height: 50px" />
          </div>
        </span>
        <span slot="packageType" slot-scope="text, record">
          <a-tooltip placement="topLeft" :title="record.packageType | formStatus(packageType)">
            <span class="text-ellipsis">{{ record.packageType | formStatus(packageType) }}</span>
          </a-tooltip>
        </span>
        <span slot="status" slot-scope="text, record">
          <a-switch
            :checked="record.status === 1"
            @change="(checked) => handleStatusChange(record, checked)"
            :loading="record.statusLoading"
            checked-children="启用"
            un-checked-children="禁用"
          />
        </span>
        <span slot="packageName" slot-scope="text, record">
          <a-tooltip placement="topLeft" :title="record.packageName">
            <span class="text-ellipsis">{{ record.packageName }}</span>
          </a-tooltip>
        </span>
        <span slot="price" slot-scope="text, record">
          <a-tooltip placement="topLeft" :title="record.price">
            <span class="text-ellipsis">{{ record.price }}</span>
          </a-tooltip>
        </span>
        <span slot="unitPrice" slot-scope="text, record">
          <a-tooltip placement="topLeft" :title="record.unitPrice">
            <span class="text-ellipsis">{{ record.unitPrice }}</span>
          </a-tooltip>
        </span>
        <span slot="validDays" slot-scope="text, record">
          <a-tooltip placement="topLeft" :title="record.validDays">
            <span class="text-ellipsis">{{ record.validDays }}</span>
          </a-tooltip>
        </span>
        <span slot="capacity" slot-scope="text, record">
          <a-tooltip placement="topLeft" :title="record.capacity">
            <span class="text-ellipsis">{{ $formatCapacity(record.capacity )}}</span>
          </a-tooltip>
        </span>
        <span slot="description" slot-scope="text, record">
          <a-tooltip placement="topLeft" :title="record.description">
            <span class="text-ellipsis">{{ record.description }}</span>
          </a-tooltip>
        </span>
        <span slot="createTime" slot-scope="text, record">
          <a-tooltip placement="topLeft" :title="record.createTime">
            <span class="text-ellipsis">{{ record.createTime }}</span>
          </a-tooltip>
        </span>
        <span slot="action" slot-scope="text, record">
          <a @click="kuorong(record, undefined)" v-hasPermi="['edc3d11367c10d4dd99dddeaf314fcecr:0:r']"> 扩容信息 </a>
          <a-divider
            type="vertical"
            v-hasPermi="['edc3d11367c10d4dd99dddeaf314fcecr:0:r', 'edc3d11367c10d4dd99dddeaf314fcecd:0:s']"
            v-if="record.status === 0"
          />
          <a-dropdown v-hasPermi="['edc3d11367c10d4dd99dddeaf314fcecr:0:r', 'edc3d11367c10d4dd99dddeaf314fcecd:0:s']" v-if="record.status === 0">
            <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
              <a-icon type="double-right" />
              更多
            </a>
            <a-menu slot="overlay">
              <a-menu-item v-hasPermi="['edc3d11367c10d4dd99dddeaf314fcecr:0:r']" >
                <a @click="handleDelete(record, undefined)">删除</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>
<script>
import { fetchList, delObj, editStatus, fetchLists } from '@/api/VR/storagePackage'
import CreateForm from './modules/CreateForm.vue'
import { tableMixin } from '@/store/table-mixin'
import parameter from '@/mixins/parameter'
import moment from 'moment'
import { mapGetters } from 'vuex'
export default {
  name: 'ParentPackage',
  components: {
    CreateForm,
  },
  mixins: [tableMixin, parameter],
  computed: {
    userType() {
      return this.$store.state.user.userTentant.type
    },
    ...mapGetters(['userTentant', 'infoUser']),
  },
  data() {
    return {
      list: [],
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        packageType: 1,
      },
      isSingleSelect: false,
      total: 0,
      value: [],
      advanced: false,
      loading: false,
      selectedRowKeys: [],
      columns: [
        {
          title: '名称',
          dataIndex: 'packageName',
          width: '140px',
          key: 'packageName',
          align: 'center',
          scopedSlots: { customRender: 'packageName' },
        },
        {
          title: '类型',
          width: '90px',
          dataIndex: 'packageType',
          scopedSlots: { customRender: 'packageType' },
          key: 'packageType',
          align: 'center',
        },
        {
          title: '容量',
          dataIndex: 'capacity',
          width: '100px',
          key: 'capacity',
          align: 'center',
          scopedSlots: { customRender: 'capacity' },
        },
        {
          title: '价格',
          dataIndex: 'price',
          width: '80px',
          align: 'center',
          scopedSlots: { customRender: 'price' },
        },
        {
          title: '单价(元/GB)',
          dataIndex: 'unitPrice',
          width: '95px',
          align: 'center',
          scopedSlots: { customRender: 'unitPrice' },
        },
        {
          title: '有效期(天)',
          dataIndex: 'validDays',
          width: '90px',
          align: 'center',
          scopedSlots: { customRender: 'validDays' },
        },
        {
          title: '状态',
          dataIndex: 'status',
          width: '85px',
          scopedSlots: { customRender: 'status' },
          align: 'center',
        },
        
        
        {
          title: '创建时间',
          dataIndex: 'createTime',
          width: '120px',
          align: 'center',
          scopedSlots: { customRender: 'createTime' },
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '180px',
          scopedSlots: { customRender: 'action' },
          align: 'center',
          fixed: 'right',
        },
      ],
    }
  },
  methods: {
    kuorong(record, index) {
      this.$router.push({
        path: '/VR/ExpansionRules',
        query: {
          id: record.id,
          packageName: record.packageName,
          packageType: record.packageType,
        },
      })
    },
    handleEdit(record) {
      this.$refs.CreateForm.handleUpdate(record)
    },
    getList() {
      this.loading = true
      if (this.userType == 0) {
        fetchList(this.queryParam).then((res) => {
          this.list = res.data.records.map((item) => ({
            ...item,
            statusLoading: false,
          }))
          this.total = res.data.total
          this.loading = false
        })
      } else {
        fetchList(this.queryParam).then((res) => {
          this.list = res.data.records.map((item) => ({
            ...item,
            statusLoading: false,
          }))
          this.total = res.data.total
          this.loading = false
        })
      }
    },
    handleStatusChange(record, checked) {
      const newStatus = checked ? 1 : 0
      const actionText = checked ? '启用' : '禁用'

      this.$confirm({
        title: `确认${actionText}`,
        content: `确定要${actionText} "${record.packageName}" 规则吗？`,
        onOk: () => {
          record.statusLoading = true
          return editStatus({ id: record.id })
            .then(() => {
              record.status = newStatus
              this.$message.success(`${actionText}成功`)
              this.getList()
            })
            .catch(() => {
              this.$message.error(`${actionText}失败`)
            })
            .finally(() => {
              record.statusLoading = false
            })
        },
        onCancel: () => {},
      })
    },
    handleDelete(row) {
      var that = this
      let ids = []
      let records = []
      
      if (row.id) {
        ids = [row.id]
        records = [row]
      } else {
        ids = this.ids
        records = this.selectedRows || []
      }
      
      // 检查是否有启用的套餐
      const enabledPackages = records.filter(record => record.status === 1)
      
      if (enabledPackages.length > 0) {
        const packageNames = enabledPackages.map(pkg => pkg.packageName).join('、')
        this.$message.warning(`以下套餐已启用，不允许删除：${packageNames}`)
        return
      }
      
      this.$confirm({
        title: '是否确认删除此数据?',
        content: '删除后将无法恢复，请谨慎操作',
        onOk() {
          return delObj(ids).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() {},
      })
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        packageType: 1,
      }
      this.value = []
      this.handleQuery()
    },
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download(
            'vr/storage/package/export',
            {
              ...that.queryParam,
            },
            `post_${new Date().getTime()}.xlsx`
          )
        },
        onCancel() {},
      })
    },
    onChangeTime(e) {
      this.queryParam.createBeginTime = moment(e[0]).startOf('day').format('YYYY-MM-DD') + ' 00:00:00'
      this.queryParam.createEndTime = moment(e[1]).endOf('day').format('YYYY-MM-DD') + ' 23:59:59'
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
  },
  created() {
    this.getList()
  },
}
</script>
<style lang="less" scoped>
.ant-table {
  .text-ellipsis {
    display: inline-block;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: middle;
  }
}

.ant-table-thead > tr > th,
.ant-table-tbody > tr > td {
  text-align: center;
  vertical-align: middle;
}

.table-operations {
  margin-bottom: 16px;
  display: flex;
  gap: 8px;
}

.ant-table-pagination {
  margin-top: 16px;
  text-align: center;
}

.table-page-search-wrapper {
  margin-bottom: 16px;
}

.ant-form-item {
  margin-bottom: 16px;
}

.ant-table-wrapper {
  overflow-x: auto;
}

/* 确保表格滚动条显示在底部 */
.ant-table-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 200px;
}

.ant-table {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.ant-table-content {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.ant-table-header {
  flex-shrink: 0;
}

.ant-table-body {
  flex: 1;
  overflow: auto !important;
  display: flex;
  flex-direction: column;
  
  /* 强制水平滚动条在底部显示 */
  &::after {
    content: '';
    display: block;
    height: 1px;
    min-height: 8px;
  }
}

.ant-table-scroll {
  display: flex;
  flex-direction: column;
  flex: 1;
  
  .ant-table-body {
    overflow-x: auto !important;
    overflow-y: auto;
  }
}

/* 空表格时的特殊处理 */
.ant-table-empty {
  .ant-table-body {
    position: relative;
    
    .ant-table-placeholder {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      border-top: 1px solid #e8e8e8;
    }
  }
}

.ant-table-tbody > tr > td {
  padding: 4px;
  font-size: 12px;
}

.ant-table-thead > tr > th {
  padding: 6px 4px;
  font-weight: 600;
  font-size: 12px;
}

/* 确保滚动条在Webkit浏览器中正确显示 */
.ant-table-body::-webkit-scrollbar {
  height: 6px;
}

.ant-table-body::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.ant-table-body::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.ant-table-body::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>